import React from 'react';
import { ShieldCheck, X, Check, Lock } from 'lucide-react';

interface SecurityModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SecurityModal: React.FC<SecurityModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card" style={{ maxWidth: 620 }}>
        {/* Header */}
        <div
          style={{
            padding: '20px 24px',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'linear-gradient(180deg, rgba(16, 185, 129, 0.08) 0%, transparent 100%)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div
              style={{
                width: 38,
                height: 38,
                borderRadius: 10,
                background: 'rgba(16, 185, 129, 0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#059669',
              }}
            >
              <ShieldCheck size={22} />
            </div>
            <div>
              <h3 style={{ fontSize: 17, fontWeight: 700, color: '#0B192C', margin: 0 }}>
                Polityka Bezpieczeństwa i Ochrony Prywatności
              </h3>
              <div style={{ fontSize: 12, color: '#059669', fontWeight: 600, marginTop: 2 }}>
                Gwarancja braku dostępu do korespondencji i prywatnych e-maili
              </div>
            </div>
          </div>

          <button onClick={onClose} className="btn btn-outline" style={{ padding: 6, borderRadius: 8 }}>
            <X size={16} />
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: 18 }}>
          {/* Main Statement */}
          <div
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 10,
              padding: 16,
              fontSize: 13,
              lineHeight: 1.6,
              color: '#334155',
            }}
          >
            System <strong style={{ color: '#0066FF' }}>CerebroSign</strong> został zaprojektowany w oparciu o
            najbardziej rygorystyczne standardy bezpieczeństwa Google Workspace.
            Aplikacja <strong style={{ color: '#dc2626' }}>NIGDY</strong> nie prosi ani nie posiada uprawnień
            do czytania poczty, przeglądania skrzynek odbiorczych, wysyłania wiadomości w imieniu
            użytkownika ani wglądu w korespondencję.
          </div>

          {/* Granted Scopes Table */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', marginBottom: 8, letterSpacing: 0.5 }}>
              Zakres uprawnień integracji Google:
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {/* Scope 1 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 12,
                  padding: 12,
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: 8,
                }}
              >
                <div style={{ color: '#059669', marginTop: 2 }}>
                  <Check size={18} />
                </div>
                <div>
                  <div style={{ fontSize: 12, color: '#0066FF', fontWeight: 600 }}>
                    Katalog pracowników organizacji (Tylko odczyt)
                  </div>
                  <div style={{ fontSize: 12, color: '#475569', marginTop: 2 }}>
                    <strong>Tylko odczyt</strong> podstawowych danych z katalogu domeny (imię, nazwisko, stanowisko, telefon, email) w celu uzupełnienia pól w szablonie stopki.
                  </div>
                </div>
              </div>

              {/* Scope 2 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 12,
                  padding: 12,
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: 8,
                }}
              >
                <div style={{ color: '#059669', marginTop: 2 }}>
                  <Check size={18} />
                </div>
                <div>
                  <div style={{ fontSize: 12, color: '#0066FF', fontWeight: 600 }}>
                    Ustawienia podpisu konta Gmail
                  </div>
                  <div style={{ fontSize: 12, color: '#475569', marginTop: 2 }}>
                    <strong>Tylko modyfikacja podpisu</strong> w ustawieniach konta pracownika. Całkowity brak dostępu do wiadomości, folderów, etykiet czy załączników.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Enterprise Encryption & Compliance */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 12,
              padding: 12,
              background: 'rgba(0, 102, 255, 0.05)',
              border: '1px solid rgba(0, 102, 255, 0.20)',
              borderRadius: 8,
            }}
          >
            <Lock size={18} color="#0066FF" style={{ marginTop: 2, flexShrink: 0 }} />
            <div style={{ fontSize: 12, color: '#334155', lineHeight: 1.5 }}>
              <strong>Szyfrowanie i ochrona danych (RODO / GDPR):</strong> Cała komunikacja z API Google
              odbywa się przez szyfrowane połączenia TLS 1.3. Żadne hasła, wiadomości ani treści prywatne
              nie są przechowywane ani przetwarzane na naszych serwerach.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '14px 24px',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'flex-end',
            background: '#f8fafc',
          }}
        >
          <button onClick={onClose} className="btn btn-primary">
            Rozumiem, przejdź do aplikacji
          </button>
        </div>
      </div>
    </div>
  );
};
